// extracted by mini-css-extract-plugin
export default {"separator-container":"Separator_separator-container__iTEc7","horizontal":"Separator_horizontal__UQINy","vertical":"Separator_vertical__V-0XR"};